<div class="document-block">
  <div class="row" style="padding: 1px;">
    <div class="col-sm-12 col-xs-12 col-md-12 col-lg-12 col-xl-4">
      <div class="profile-left-panel">
        <div class="mb-3">
          <div class="row document-edit-div">
            <div class="col-md-9 flex">
              <p-dropdown [options]="groupedAssests" [(ngModel)]="selectedAssest" [style]="{'width':'100%'}"
                placeholder="Select an Applicant" [group]="true" optionLabel="label">
                <ng-template let-group pTemplate="group">
                  <div class="flex">
                    <span>{{ group.label }}</span>
                  </div>
                </ng-template>
              </p-dropdown>
            </div>
            <div class="col-md-3  document-editbutton">
              <img src="../../../assets/images/editIcon.svg" class="editbtn" (click)="editUserProfile()">
            </div>
          </div>
          <div class="bottom-block">
            <div class="profile-thumb text-center">
              <div class="avatar-upload">
                <div class="avatar-edit">
                  <div class="avatar-preview">
                    <a class="lead-info">
                      <img src="{{ userProfileImage }}" width="100" height="100">
                    </a>
                  </div>
                  <span class="profile-plushIcon">
                    <img src="{{ userProfilePicOperationIcon }}" height="20" width="20" data-toggle="modal"
                      (click)="setCurrentFileConfig('Photo')">
                  </span>
                </div>
              </div>
            </div>
            <div class="thumb-content text-center mb-3">
              <h3>{{userProfileData?.nameInitial?.name}} {{userProfileData?.firstName}} {{userProfileData?.lastName}}
              </h3>
            </div>
            <div class="thumb-content text-center mb-3">
              <div class="row text-center d-flex">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 justify-content-center d-flex">
                  <div class="" (click)="communicationIconClick()">
                    <img src="../../../assets/images/communication icon.svg" class="icon ml-2 "
                      height="25">&nbsp;Communication
                  </div>
                  <div (click)="recieptClick()">
                    <img src="../../../../assets/images/Receipt Icon.svg" class="icon ml-2 " height="25">
                    Reciept
                  </div>
                </div>
              </div>
            </div>
            <div class="headtext">
              <div class="head mb-3 p-1">
                <strong id="document">Name and Contact.</strong>
              </div>
            </div>
            <div class="p-10-15">
              <div class="d-flex">
                <p><b>Father/Husband.</b></p>:- &nbsp; <p>
                  {{userProfileData?.fatherHusbandName}}</p>
              </div>
              <div class="mb-1 d-flex">
                <p><b>Phone No.</b></p>:- &nbsp; <p>{{userProfileData?.primaryPhoneNo}}</p>
              </div>
              <div class="d-flex">
                <p><b>Current Address.</b></p>:- &nbsp; <p>{{(this.currentAddress)?this.currentAddress:''}}</p>
              </div>
              <div class="mb-1 d-flex">
                <p><b>Permanant Address.</b></p>:- &nbsp; <p>{{this.permanentAddress}}</p>
              </div>
            </div>
            <div class="headtext">
              <div class="head mb-3 p-1">
                <strong id="document">Identification</strong>
              </div>
            </div>
            <div class="p-10-15">
              <div class="d-flex">
                <p><b>Adhar Card No.</b></p>:- &nbsp; <p>{{userProfileData?.aadharNumber}}</p>
              </div>
              <div class="mb-1 d-flex">
                <p><b>PAN Card No.</b></p>:- &nbsp; <p>{{userProfileData?.panCardNo}}</p>
              </div>
              <div class="d-flex">
                <p><b>Religion.</b></p>:- &nbsp; <p>{{userProfileData?.community?.religionName}}</p>
              </div>
              <div class="mb-1 d-flex">
                <p><b>Community.</b></p>:- &nbsp; <p>{{userProfileData?.community?.name}}</p>
              </div>
              <div class="mb-1 d-flex">
                <p><b>Gender.</b></p>:- &nbsp; <p>{{userProfileData?.gender}}</p>
              </div>
            </div>

            <!-- <div class="bankIcon">
                  <img src="../../../../assets/images/Add Bank Icon.svg" data-toggle="modal" data-target="#bankModal" />
                </div> -->
            <div class="headtext">
              <div class="head mb-3 p-1">
                <strong id="document">Bank Account Info.</strong>
              </div>
            </div>
            <div class="p-10-15" *ngIf="userProfileData?.bankAccounts">
              <div class="mb-1 d-flex">
                <p><b>Bank Account Holder Name.</b></p>:- &nbsp; <p>{{userProfileData?.bankAccounts &&
                  userProfileData?.bankAccounts[0]?.accountHolderName}}</p>
              </div>
              <div class="mb-1 d-flex">
                <p><b>Bank Account No.</b></p>:- &nbsp; <p>{{userProfileData?.bankAccounts &&
                  userProfileData?.bankAccounts[0]?.bankAccountNo}}</p>
              </div>
              <div class="mb-1 d-flex">
                <p><b>IFSC.</b></p>:- &nbsp; <p>{{userProfileData?.bankAccounts &&
                  userProfileData?.bankAccounts[0]?.ifsc}}</p>
              </div>
              <div class="mb-1 d-flex">
                <p><b>Bank Address</b></p>:- &nbsp; <p class="break-text">{{userProfileData?.bankAccounts &&
                  userProfileData?.bankAccounts[0]?.branchAddress}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!--Document Pic upload modal. For uploading document this modal will open -->
<p-dialog [(visible)]="displayDocumentPicDialogue" [modal]="true" [draggable]="false" [resizable]="false"
  [blockScroll]=false [style]="{ width: '30rem' }" (onHide)="receiveCurrentUserProfilePic($event)">
  <p-header>
    Upload {{ documentFileData?.picFor }} Pic
  </p-header>
  <app-document-file [fileDataConfig]='documentFileData'
    (documentFile)="receiveCurrentUserProfilePic($event)"></app-document-file>
</p-dialog>